import type { Community } from './community';

export interface Announcement {
  id: number;
  subject: string;
  message: string;
  type: AnnouncementTypes;
  board_members_only: boolean;
  send_email: boolean;
  send_push: boolean;
  send_sms: boolean;
  status: AnnouncementStatus;
  community_id: number;
  community?: Community;
  scheduled_at?: string;
  processed_on: string;
  created_at: string;
  updated_at: string;
  created_by: number;
  files?: File[]
}

export const Announcement_Type = {
  1: 'General',
  2: 'Maintenance',
  3: 'Emergency',
  GENERAL: 'General',
  MAINTENANCE: 'Maintenance',
  EMERGENCY: 'Emergency',
} as const;
export type AnnouncementTypes = keyof typeof Announcement_Type;

export const Announcement_Status = {
  1: 'Draft',
  2: 'Cancelled',
  3: 'Failed',
  4: 'Pending',
  5: 'Processing',
  6: 'Published',
  DRAFT: 'Draft',
  CANCELLED: 'Cancelled',
  FAILED: 'Failed',
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  PUBLISHED: 'Published',
} as const;
export type AnnouncementStatus = keyof typeof Announcement_Status;
